import { lazy, Suspense } from "react";
import { useModulePermissions } from "@/context/ModulePermissionsContext";
import { useCanAccessGuardians } from "@/hooks/useCanAccessGuardians";
import { useCanMissionOps } from "@/hooks/useCanMissionOps";
import type { TaskThreadOpsMenuProps } from "./TaskThreadOpsMenu";

const TaskThreadOpsMenu = lazy(() =>
  import("./TaskThreadOpsMenu").then((module) => ({
    default: module.TaskThreadOpsMenu,
  })),
);

/** Ops / guardians menu — code-split; omitted entirely when user lacks access. */
export function TaskThreadOpsMenuSlot(props: TaskThreadOpsMenuProps) {
  const { hasPermission } = useModulePermissions();
  const canAccessGuardians = useCanAccessGuardians();
  const canMissionOps = useCanMissionOps();
  if (!hasPermission("ops") && !canAccessGuardians && !canMissionOps) {
    return null;
  }
  return (
    <Suspense fallback={null}>
      <TaskThreadOpsMenu {...props} />
    </Suspense>
  );
}
